/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OrgUptimeSummary
 */
export interface OrgUptimeSummary {
    /**
     * Organisation device group tag
     * @type {string}
     * @memberof OrgUptimeSummary
     */
    deviceGroupTag?: string;
    /**
     * Organisation name
     * @type {string}
     * @memberof OrgUptimeSummary
     */
    orgName?: string;
    /**
     * Number of chargers in this organisation
     * @type {number}
     * @memberof OrgUptimeSummary
     */
    chargerCount?: number;
    /**
     * Average device uptime percentage (0-1). Offline periods are not considered.
     * @type {number}
     * @memberof OrgUptimeSummary
     */
    avgDeviceUptimeOfflineIncluded?: number;
    /**
     * Average device uptime percentage (0-1). Offline periods are removed from calculation.
     * @type {number}
     * @memberof OrgUptimeSummary
     */
    avgDeviceUptimeOfflineExcluded?: number;
    /**
     * Preferred device uptime based on organisation preference.
     * @type {number}
     * @memberof OrgUptimeSummary
     */
    preferredDeviceUptime?: number;
    /**
     * Whether offline is included in device uptime calculation.
     * @type {boolean}
     * @memberof OrgUptimeSummary
     */
    isOfflineIncludedInDeviceUptime?: boolean;
    /**
     * Calculation period start
     * @type {Date}
     * @memberof OrgUptimeSummary
     */
    periodStart?: Date;
    /**
     * Calculation period end
     * @type {Date}
     * @memberof OrgUptimeSummary
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the OrgUptimeSummary interface.
 */
export function instanceOfOrgUptimeSummary(
    value: object,
): value is OrgUptimeSummary {
    return true;
}

export function OrgUptimeSummaryFromJSON(json: any): OrgUptimeSummary {
    return OrgUptimeSummaryFromJSONTyped(json, false);
}

export function OrgUptimeSummaryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OrgUptimeSummary {
    if (json == null) {
        return json;
    }
    return {
        deviceGroupTag:
            json["deviceGroupTag"] == null ? undefined : json["deviceGroupTag"],
        orgName: json["orgName"] == null ? undefined : json["orgName"],
        chargerCount:
            json["chargerCount"] == null ? undefined : json["chargerCount"],
        avgDeviceUptimeOfflineIncluded:
            json["avgDeviceUptimeOfflineIncluded"] == null
                ? undefined
                : json["avgDeviceUptimeOfflineIncluded"],
        avgDeviceUptimeOfflineExcluded:
            json["avgDeviceUptimeOfflineExcluded"] == null
                ? undefined
                : json["avgDeviceUptimeOfflineExcluded"],
        preferredDeviceUptime:
            json["preferredDeviceUptime"] == null
                ? undefined
                : json["preferredDeviceUptime"],
        isOfflineIncludedInDeviceUptime:
            json["isOfflineIncludedInDeviceUptime"] == null
                ? undefined
                : json["isOfflineIncludedInDeviceUptime"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function OrgUptimeSummaryToJSON(value?: OrgUptimeSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceGroupTag: value["deviceGroupTag"],
        orgName: value["orgName"],
        chargerCount: value["chargerCount"],
        avgDeviceUptimeOfflineIncluded: value["avgDeviceUptimeOfflineIncluded"],
        avgDeviceUptimeOfflineExcluded: value["avgDeviceUptimeOfflineExcluded"],
        preferredDeviceUptime: value["preferredDeviceUptime"],
        isOfflineIncludedInDeviceUptime:
            value["isOfflineIncludedInDeviceUptime"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
